import React from 'react'
import { LoaderText, LoaderWrapper, Wrapper } from './style'

export const Loader = ({ isActive, animation, ...props }) => {
	return (
		<Wrapper isActive={isActive} {...props}>
			{animation}
		</Wrapper>
	)
}

export const LoaderSpinner = ({
	isActive,
	isImageUploader = false,
	...rest
}) => {
	return (
		<LoaderWrapper
			isImageUploader={isImageUploader}
			isActive={isActive}
			{...rest}
		>
			<LoaderText>Loading...</LoaderText>
		</LoaderWrapper>
	)
}
